exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base-document{width:8.5in;min-height:11in}@page{size:8.5in 11in;margin:.5in}@media print{html,body,.main,.content{height:11.3in !important}#app{width:8.5in !important}#app .base-document{min-height:11.3in;height:11.3in;width:8.5in}}\n", ""]);

// exports
